<template>
  <div>
    <v-main>
      <div>
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="12">
                <v-card rounded="t-xl">
                  <v-list three-line subheader>
                    <!-- ADD -->
                    <v-dialog v-model="dialogAdd" fullscreen>
                      <v-card>
                        <v-toolbar color="indigo" dark>
                          <v-toolbar-title>เพิ่มข้อมูล</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn
                            icon
                            dark
                            @click="(dialogAdd = false), clearData()"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-toolbar>
                        <v-card-text>
                          <v-container>
                            <v-form
                              ref="form_add"
                              v-model="valid_add"
                              lazy-validation
                            >
                              <v-row>
                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="formAdd.familyStatus"
                                    :items="family_status"
                                    :rules="nameRules"
                                    label="ความสัมพันธ์ *"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="formAdd.familyTitleName"
                                    :items="titleNameTH"
                                    :rules="nameRules"
                                    label="คำนำหน้า *"
                                    required
                                    dense
                                    outlined
                                    placeholder="Select..."
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="formAdd.familyFirstName"
                                    label="ชื่อ *"
                                    :counter="50"
                                    maxlength="50"
                                    :rules="nameRules"
                                    required
                                    dense
                                    outlined
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="formAdd.familyLastName"
                                    label="นามสกุล *"
                                    :counter="50"
                                    maxlength="50"
                                    :rules="nameRules"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="formAdd.familyBirthDay"
                                        :return-value.sync="date"
                                        label="ปี-เดือน เกิด *"
                                        readonly
                                        :rules="nameRules"
                                        dense
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="formAdd.familyBirthDay"
                                      locale="th"
                                      no-title
                                      scrollable
                                      @change="$refs.menu.save(date)"
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="formAdd.familyAlive"
                                    :items="familyStatusAlive"
                                    label="สถานภาพ"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="formAdd.familyCareer"
                                    :items="masterCareer"
                                    label="อาชีพ"
                                    clearable
                                    clear-icon="mdi-close-circle"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    type="tel"
                                    v-model="formAdd.familySalary"
                                    label="รายได้"
                                    :counter="6"
                                    maxlength="6"
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="formAdd.familyAddress"
                                    label="ที่อยู่/สถานที่ทำงาน"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="formAdd.familyEducationLeavel"
                                    :items="masterEducationLeavel"
                                    label="ระดับการศึกษา"
                                    clearable
                                    clear-icon="mdi-close-circle"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="formAdd.familyTel"
                                    label="เบอร์โทรศัพท์"
                                    :counter="10"
                                    maxlength="10"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="4"
                                  class="pt-0 mt-0 pb-0 mb-0 text-right"
                                >
                                  <v-checkbox
                                    v-model="formAdd.emergencyStatus"
                                    :label="`เป็นผู้ติดต่อกรณีฉุกเฉิน`"
                                    required
                                    dense
                                  ></v-checkbox>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="4"
                                  class="pt-0 mt-0 pb-0 mb-0 text-right"
                                >
                                  <v-checkbox
                                    v-model="formAdd.familyStayWithFamStatus"
                                    :label="`อยู่ร่วมกัน`"
                                    required
                                    dense
                                  ></v-checkbox>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="4"
                                  class="pt-0 mt-0 pb-0 mb-0 text-right"
                                >
                                  <v-checkbox
                                    v-model="formAdd.familyVerifyInfo"
                                    :label="`*ยินยอมให้บริการข้อมูลนี้ เพื่อเข้าร่วมโครงการ`"
                                    required
                                    dense
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-form>
                            <v-card-actions>
                              <v-col class="text-center">
                                <v-btn
                                  v-if="formAdd.familyVerifyInfo"
                                  elevation="2"
                                  x-large
                                  color="success"
                                  text
                                  :disabled="!valid_add"
                                  @click="addData()"
                                >
                                  <v-icon left
                                    >mdi-checkbox-marked-circle</v-icon
                                  >
                                  เพิ่มข้อมูล
                                </v-btn>
                              </v-col>
                            </v-card-actions>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <!-- end add -->

                    <v-app-bar fixed app no-gutters color="indigo" dark>
                      <v-toolbar-title>ประวัติครอบครัว</v-toolbar-title>

                      <v-col class="text-right">
                        <v-btn icon @click="closePage()">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-app-bar>
                    <v-col class="pa-2">
                      <v-alert
                        v-if="dataFamily.length == 0"
                        border="right"
                        colored-border
                        type="error"
                        elevation="20"
                      >
                        กรุณากรอกข้อมูลให้ครบถ้วนเพื่อสิทธิประโยชน์ของท่าน
                      </v-alert>
                    </v-col>
                    <v-row class="pa-2">
                      <v-col class="text-center pt-5">
                        จำนวน {{ dataFamily.length }} รายการ
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          v-if="can"
                          color="primary"
                          depressed
                          @click="
                            (dialogAdd = true), validate('ADD'), clearData()
                          "
                        >
                          <v-icon left>mdi-text-box-plus</v-icon>
                          เพิ่มข้อมูล
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider color="#871B12"></v-divider>
                    <div v-for="(items, index) in dataFamily" :key="index">
                      <v-card elevation="20">
                        <v-subheader>
                          {{ items.familyStatus }}
                          <v-icon>mdi-human-male-boy</v-icon>
                          <v-col class="text-right">
                            <v-btn
                              v-if="can"
                              small
                              color="error"
                              @click="deleteEducation(items)"
                            >
                              <v-icon small>mdi-close</v-icon>
                              ลบข้อมูล
                            </v-btn>
                          </v-col>
                        </v-subheader>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-form
                            ref="form_update"
                            v-model="valid_update"
                            lazy-validation
                          >
                            <v-container class="py-0">
                              <v-row>
                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="items.familyTitleName"
                                    :items="titleNameTH"
                                    label="คำนำหน้า *"
                                    :readonly="!can"
                                    required
                                    dense
                                    outlined
                                    placeholder="Select..."
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="items.familyFirstName"
                                    label="ชื่อ *"
                                    :rules="nameRules"
                                    :readonly="!can"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="items.familyLastName"
                                    label="นามสกุล *"
                                    :rules="nameRules"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <!-- <v-dialog
                                  v-model="dialogDate"
                                  max-width="600px"
                                >
                                  <v-card>
                                    {{ familyBirthDay }}
                                    <v-col cols="12" sm="6" md="4">
                                      <v-menu
                                        ref="menuDate"
                                        v-model="menuDate"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-text-field
                                            v-model="familyBirthDay"
                                            :return-value.sync="date"
                                            label="ปี-เดือน เกิด *"
                                            readonly
                                            :rules="nameRules"
                                            dense
                                            outlined
                                            v-bind="attrs"
                                            v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="familyBirthDay"
                                          no-title
                                          scrollable
                                        >
                                          <v-spacer></v-spacer>
                                          <v-btn
                                            text
                                            color="primary"
                                            @click="menu = false"
                                          >
                                            Cancel
                                          </v-btn>
                                          <v-btn
                                            locale="th"
                                      no-title
                                      scrollable
                                      @change="$refs.menu.save(date)"
                                          >
                                            OK
                                          </v-btn>
                                        </v-date-picker>
                                      </v-menu>
                                    </v-col>
                                  </v-card>
                                </v-dialog> -->

                                <v-col cols="6" sm="4">
                                  <v-menu
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="items.familyBirthDay"
                                        :return-value.sync="date"
                                        label="ปี-เดือน เกิด *"
                                        readonly
                                        :rules="nameRules"
                                        dense
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="items.familyBirthDay"
                                      locale="th"
                                      no-title
                                      scrollable
                                      @change="getDate(items)"
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                    <v-col cols="6" sm="4">
                                  <v-text-field
                                    v-model="items.FamiliyAge"
                                    label="อายุ"
                                    disabled
                                    required
                                    dense
                                    outlined
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="items.familyAlive"
                                    :items="familyStatusAlive"
                                    label="สถานภาพ"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="items.familyCareer"
                                    :items="masterCareer"
                                    clearable
                                    clear-icon="mdi-close-circle"
                                    label="อาชีพ"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="items.familySalary"
                                    label="รายได้"
                                    :counter="6"
                                    maxlength="6"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="items.familyAddress"
                                    label="ที่อยู่/สถานที่ทำงาน"
                                    :counter="50"
                                    maxlength="50"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    v-model="items.familyEducationLeavel"
                                    :items="masterEducationLeavel"
                                    label="ระดับการศึกษา"
                                    required
                                    clearable
                                    clear-icon="mdi-close-circle"
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>

                                <v-col cols="12" sm="4">
                                  <v-text-field
                                    v-model="items.familyTel"
                                    label="เบอร์โทรศัพท์"
                                    :counter="10"
                                    maxlength="10"
                                    type="tel"
                                    :rules="numberRules"
                                    required
                                    dense
                                    outlined
                                  />
                                </v-col>

                                <v-col
                                  cols="12"
                                  sm="4"
                                  class="pt-0 mt-0 pb-0 mb-0 text-right"
                                >
                                  <v-checkbox
                                    v-model="items.emergencyStatus"
                                    :label="`เป็นผู้ติดต่อกรณีฉุกเฉิน`"
                                    false-value="False"
                                    true-value="True"
                                  ></v-checkbox>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="4"
                                  class="pt-0 mt-0 pb-0 mb-0 text-right"
                                >
                                  <v-checkbox
                                    v-model="items.familyStayWithFamStatus"
                                    :label="`อยู่ร่วมกัน`"
                                    false-value="False"
                                    true-value="True"
                                  ></v-checkbox>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="4"
                                  class="pt-0 mt-0 text-right"
                                >
                                  <v-checkbox
                                    v-model="items.familyVerifyInfo"
                                    :label="`*ยินยอมให้บริการข้อมูลนี้ เพื่อเข้าร่วมโครงการ`"
                                    false-value="False"
                                    true-value="True"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-col cols="12" class="text-right">
                                <v-btn
                                  small
                                  color="success"
                                  class="mr-0"
                                  :disabled="items.familyVerifyInfo == 'False'"
                                  @click="editData(items)"
                                >
                                  บันทึกข้อมูล
                                </v-btn>
                              </v-col>
                            </v-container>
                          </v-form>
                        </v-card-text>
                      </v-card>
                      <br />
                      <br />
                    </div>
                    <br />
                  </v-list>
                </v-card>
                <v-row no-gutters>
                  <v-footer fixed height="60px" color="#262A34">
                    <v-col class="text-right">
                      <v-btn small color="#E0E0E0" @click="pushBack(dataFamily)">
                        <v-icon left> mdi-arrow-left-circle-outline</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn small color="#E0E0E0" @click="pushNext(dataFamily)">
                        หน้าถัดไป
                        <v-icon right> mdi-arrow-right-circle-outline</v-icon>
                      </v-btn>
                    </v-col>
                  </v-footer>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment'
import titleNameTH from '../../assets/master/titleName/titleNameTH.json'
import familyStatusTH from '../../assets/master/FamilyStatus/familyStatusTH.json'
import careerTH from '../../assets/master/Career/careerTH.json'
import educationLeavel from '../../assets/master/Education/educationLavel.json'

export default {
  components: {},
  created () {},
  data () {
    return {
      PK: '',
      rollHR: false,
      path: '/employee_family_punsuk/', // Path Model
      // Menu Config
      breadcrumbs: [],
      // End Menu Config
      dataReady: true,
      valid_add: true,
      valid_update: true,
      familyBirthDay: '',
      checkbox: true,
      dateTime: '', // Generate DateTime
      dateB: new Date().toISOString().substr(0, 10),
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      menuDate: false,
      modal: false,
      dialogAdd: false,
      dialogDate: false,
      // family_status: ['พ่อ', 'แม่', 'พี่', 'น้อง', 'ภรรยา', 'สามี', 'บุตรคนที่ 1 ', 'บุตรคนที่ 2', 'ลุง', 'ป้า', 'น้า', 'อา', 'ปู่', 'ย่า', 'ตา', 'ยาย'],
      formAdd: {
        familyAlive: 'มีชีวิตอยู่'
      },
      dataFamily: [],
      numberRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9',
        (v) => (v && v.length === 10) || 'Max 10 characters'
      ],
      // numberSalary: [
      //   (v) =>
      //     (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) ||
      //     'กรุณา กรอกเป็นตัวเลข 0-9',
      //   (v) => (v && v.length === 6) || 'Max 6 characters'
      // ],
      nameRules: [(v) => !!v || 'กรุณา กรอกข้อมูลให้ถูกต้อง'],

      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      titleNameTH: titleNameTH,
      masterCareer: careerTH,
      masterEducationLeavel: educationLeavel,
      family_status: familyStatusTH,
      familyStatusAlive: ['มีชีวิตอยู่', 'ถึงแก่กรรม'],
      familyID: '',
      dataEmp: '',
      can: true,
      profile: []
    }
  },
  async mounted () {
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    await this.getDataByFamily()
  },
  methods: {
    // checkStatus () {
    //   let rs = this.dataFamily
    //   if (rs.length > 0) {
    //     for (var i = 0; i < rs.length; i++) {
    //       var d = rs[i]

    //       if (this.formAdd.familyStatus === d.familyStatus) {
    //         this.$swal(
    //           'โปรดตรวจสอบข้อมูล',
    //           'คุณมีข้อมูล ' + d.familyStatus + ' แล้ว',
    //           'error'
    //         )
    //         this.formAdd.familyStatus =  this.clearData()
    //         // this.formAdd.familyStatus = this.validate()
    //       }
    //     }
    //   }
    // },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    getDate (item) {
      const startDate = new Date()
      const endDate = new Date(item.familyBirthDay)
      var bd = Math.abs(moment.duration(endDate - startDate).years())
      item.FamiliyAge = bd
    },
    saveDate () {},
    async getDataByFamily () {
      this.dataFamily = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee_family_punsuk/getEmpCode?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            this.dataFamily = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          this.dataFamily = []
          console.log('error function getDataById : ', error)
        })
    },
    async addData () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ บันทึกข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            empCode: this.profile.empCode,
            familyStatus: this.formAdd.familyStatus,
            familyTitleName: this.formAdd.familyTitleName,
            familyFirstName: this.formAdd.familyFirstName,
            familyLastName: this.formAdd.familyLastName,
            familyCareer: this.formAdd.familyCareer,
            familyAddress: this.formAdd.familyAddress,
            familyTel: this.formAdd.familyTel,
            familySalary: this.formAdd.familySalary,
            familyEducationLeavel: this.formAdd.familyEducationLeavel,
            familyAlive: this.formAdd.familyAlive,
            familyVerifyInfo: this.formAdd.familyVerifyInfo,
            familyBirthDay: this.formAdd.familyBirthDay,
            emergencyStatus: this.formAdd.emergencyStatus,
            familyStayWithFamStatus: this.formAdd.familyStayWithFamStatus,
            CREATE_USER: this.profile.userName,
            LAST_USER: this.profile.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/employee_family_punsuk/add",
              ds
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.dialogAdd = false
              this.getDataByFamily()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async editData (dt) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let id = dt.familyID
          let ds = {
            familyStatus: dt.familyStatus,
            familyTitleName: dt.familyTitleName,
            familyFirstName: dt.familyFirstName,
            familyLastName: dt.familyLastName,
            familyCareer: dt.familyCareer,
            familyAddress: dt.familyAddress,
            familyTel: dt.familyTel,
            emergencyStatus: dt.emergencyStatus,
            familyStayWithFamStatus: dt.familyStayWithFamStatus,
            familySalary: dt.familySalary,
            familyBirthDay: dt.familyBirthDay,
            familyAGE: dt.familyAGE,
            familyEducationLeavel: dt.familyEducationLeavel,
            familyAlive: dt.familyAlive,
            familyVerifyInfo: dt.familyVerifyInfo,
            LAST_USER: this.profile.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + id,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dataReady = true
              this.getDataByFamily()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteEducation (d) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        let ds = {
          LAST_USER: JSON.parse(localStorage.getItem('liff_info')).userName
        }

        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + this.path + "delete/" + d.familyID,
            ds,
            {
              headers: {
                'Application-Key': localStorage.getItem('ApplicationKey')
              }
            }
          )
          .then(async (response) => {
            // Debug response
            this.$swal('เรียบร้อย', 'ลบข้อมูล เรียบร้อย', 'success')
            this.getDataByFamily()
            this.dataFamily = []
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.dataReady = true
            console.log('error function deleteDataGlobal : ', error)
          })
      })
    },
    async clearData () {
      this.formAdd = []
      // this.formAdd.familyStatus
      // if (this.dataFamily.length > 1) {
      this.dataFamily.forEach((element) => {
        var myIndex = this.family_status.indexOf(element.familyStatus)
        if (myIndex !== -1) {
          this.family_status.splice(myIndex, 1)
        }
      })
      // }
    },
    closePage () {
      this.$router.push('/Liff/HomeEmployee')
    },
    async pushNext () {
      if (this.dataFamily.length > 0) {
        // this.$swal({
        //   title: 'บันทึกการ แก้ไขข้อมูล ใช่หรือไม่?',
        //   type: 'question',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#b3b1ab',
        //   confirmButtonText: 'ใช่',
        //   cancelButtonText: 'ไม่'
        // })
        //   .then(async (result) => {
        this.dataReady = false
        this.dataFamily.forEach(async (element) => {
          let ds = {
            familyID: element.familyID,
            familyStatus: element.familyStatus,
            familyTitleName: element.familyTitleName,
            familyFirstName: element.familyFirstName,
            familyLastName: element.familyLastName,
            familyCareer: element.familyCareer,
            familyAddress: element.familyAddress,
            familyTel: element.familyTel,
            emergencyStatus: element.emergencyStatus,
            familyStayWithFamStatus: element.familyStayWithFamStatus,
            familySalary: element.familySalary,
            familyBirthDay: element.familyBirthDay,
            familyEducationLeavel: element.familyEducationLeavel,
            familyAlive: element.familyAlive,
            familyVerifyInfo: element.familyVerifyInfo,
            LAST_USER: this.profile.userName
          }
          console.log('ds', ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "update",
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.dataReady = true
              // this.$router.push('/Liff/EmpAddress')
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        // })
        // .catch((error) => {
        //   this.dataReady = true
        //   console.log('error function editDataGlobal : ', error)
        // })
      }
      this.dataReady = true
      await this.$router.push('/Liff/EmpAddress')
    },
    async pushBack () {
      if (this.dataFamily.length > 0) {
        // this.$swal({
        //   title: 'บันทึกการ แก้ไขข้อมูล ใช่หรือไม่?',
        //   type: 'question',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#b3b1ab',
        //   confirmButtonText: 'ใช่',
        //   cancelButtonText: 'ไม่'
        // })
        //   .then(async (result) => {
        this.dataReady = false
        this.dataFamily.forEach(async (element) => {
          let ds = {
            familyID: element.familyID,
            familyStatus: element.familyStatus,
            familyTitleName: element.familyTitleName,
            familyFirstName: element.familyFirstName,
            familyLastName: element.familyLastName,
            familyCareer: element.familyCareer,
            familyAddress: element.familyAddress,
            familyTel: element.familyTel,
            emergencyStatus: element.emergencyStatus,
            familyStayWithFamStatus: element.familyStayWithFamStatus,
            familySalary: element.familySalary,
            familyBirthDay: element.familyBirthDay,
            familyEducationLeavel: element.familyEducationLeavel,
            familyAlive: element.familyAlive,
            familyVerifyInfo: element.familyVerifyInfo,
            LAST_USER: this.profile.userName
          }
          console.log('ds', ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "update",
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.dataReady = true
              // this.$router.push('/Liff/EmpInfomation')
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        // })
        // .catch((error) => {
        //   this.dataReady = true
        //   console.log('error function editDataGlobal : ', error)
        // })
      }
      this.dataReady = true
      await this.$router.push('/Liff/EmpInfomation')
    }
  }
}
</script>
<style scope>
.scroll {
  overflow-y: scroll;
}
.header_1 {
  font-family: Kanit;
  font-size: 20px;
  display: flex;

  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/EmpFamily.vue